// src/pages/Solutions.js
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SolutionsSection from '../../components/SolutionsSection';
import ProductionsSection from '../../components/ProductionsSection';
import ProductModulesSection from '../../components/ProductModulesSection';
import ImpactSection from '../../components/ImpactSection';
import DeploymentSection from '../../components/DeploymentSection';
import ToSuccessStoriesSection from '../../components/ToSuccessStoriesSection';

import MetropolitanPolice from "../../assets/images/MetropolitanPolice.png"
import Shenzhen from "../../assets/images/shenzhen.png"
import Chicago from "../../assets/images/chicago.png"
import WAVE2 from "../../assets/images/wave2.png"

import CrimeIcon from "../../assets/images/crime.svg"
import StreetIcon from "../../assets/images/street.svg"
import ResponseIcon from "../../assets/images/response.svg"
import IntegrationIcon from "../../assets/images/integration.svg"
import AIIcon from "../../assets/images/AI.svg"

const SpacetimeSafeCity = () => {
   const modules = [
    {
      icon: CrimeIcon,
      title: "Crime & Incident Dashboard",
      desc: "Interactive visualisation of historical and current crime data",
      useCase: "Command-centre monitoring | hotspot detection"
    },
    {
      icon: StreetIcon,
      title: "Street-Level Risk Prediction",
      desc: "Real-time probabilistic forecast (15–60-minute window)",
      useCase: "Early warning and patrol scheduling"
    },
    {
      icon: ResponseIcon,
      title: "Response Effectiveness Analytics",
      desc: "Post-incident evaluation and model retraining",
      useCase: "ESG / wellbeing reporting | continuous improvement"
    },
    {
      icon: IntegrationIcon,
      title: "Integration Layer",
      desc: "API connection to CAD / GIS / command systems",
      useCase: "Seamless data flow into existing police infrastructure"
    },
    {
      icon: AIIcon,
      title: "AI Patrol Guidance",
      desc: "Route optimisation and coverage balancing using risk maps",
      useCase: "Resource allocation | shift planning"
    },
  ];
  const impacts = [
    {
      value: "+18%",
      label: "Patrol coverage efficiency",
      source: "London pilot"
    },
    {
      value: "-12%",
      label: "Response time reduction",
      source: "Shenzhen deployment"
    },
    {
      value: "0.83 AUC",
      label: "Forecast accuracy(within 250 m grid)",
      source: "Chicago open data test"
    },
    {
      value: "+15%",
      label: "Officer workload balance",
      source: "OS / xRenewable trials"
    }
  ];
   const options = [
    "Secure cloud (ISO-27001 compliant) or on-premise",
    "Data sources: police CAD, 999/110 calls, social data, weather feeds ",
    "GDPR- and data-ethics-aligned architecture"
  ];
  return (
    <div>
      <Header />
      <SolutionsSection
        title="Predictive Public-Safety Intelligence"
        subtitle="Turning urban data into foresight for safer streets."
      />
      <ProductionsSection
        backgroundImage={WAVE2}
        title="Spacetime SafeCity™"
        descriptions={[
          "SafeCity™ is an AI-driven platform for urban safety and emergency management.",
          "It analyses historical crime, incident, and environmental data to predict high-risk zones, guide patrol deployment, and support data-driven policing and public-safety policy."
        ]}
        logos={[
          { 
            src: MetropolitanPolice, 
            alt: "MetropolitanPolice", 
            href: "#" 
          },
          { 
            src: Shenzhen, 
            alt: "Shen zhen", 
            href: "#" 
          },
          { 
            src: Chicago, 
            alt: "Chicago Data Portal", 
            href: "#" 
          }
        ]}
      />
      <ProductModulesSection modules={modules}/>
      <ImpactSection impacts={impacts}/>
      <DeploymentSection options={options}/>
      <ToSuccessStoriesSection 
        title="Empower your city with predictive, transparent, and data-driven public-safety intelligence." />
      <Footer/>
    </div>
  );
};

export default SpacetimeSafeCity;
